import { render } from "./plus.vue?vue&type=template&id=2b4a1204"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/plus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b4a1204"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b4a1204', __exports__)) {
    api.reload('2b4a1204', __exports__)
  }
  
  module.hot.accept("./plus.vue?vue&type=template&id=2b4a1204", () => {
    api.rerender('2b4a1204', render)
  })

}


export default __exports__